import React from 'react';
import { InfoTooltip as RootInfoTooltip } from '@dashboard/components/Tooltip';

function Container({ children }) {
  return (
    <div className="bg-white rounded border border-gray-100 p-4 flex flex-col gap-y-1 justify-center">
      {children}
    </div>
  );
}

function Icon({ icon }) {
  const IconComponent = icon;

  return (
    <div className="flex items-center justify-start mr-auto mb-2">
      <IconComponent className="w-8 h-8 text-chocolate-1000" />
    </div>
  );
}

function Header({ children }) {
  return <div className="flex items-center">{children}</div>;
}

function Title({ children }) {
  return <div className="text-sm text-gray-500 font-medium">{children}</div>;
}

function InfoTooltip({ children }) {
  return (
    <div className="relative">
      <RootInfoTooltip>{children}</RootInfoTooltip>
    </div>
  );
}

function Value({ children }) {
  return <div className="text-xl font-medium leading-5">{children}</div>;
}

export { Container, Icon, Header, Title, InfoTooltip, Value };
